const isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

export { isBezierDefinition };
